import { useContext, useEffect } from 'react';
import { Auth0Context } from 'src/auth0-provider';
import { push } from '@rexlabs/whereabouts';
import ROUTES from 'routes';

/**
 * HomeRedirect — renders at the root path `/`.
 *
 * Checks the Auth0 permissions to decide where to send the user:
 * - Admin users (admin-app:general-access) → /admin (new admin UI, full page nav)
 * - Everyone else → /app/projects/current (old frontend, SPA nav)
 */
export default function HomeRedirect() {
  const { permissions } = useContext(Auth0Context);

  useEffect(() => {
    if (!permissions || permissions.length === 0) return;
    if (permissions.includes('admin-app:general-access')) {
      window.location.href = '/admin';
    } else if (permissions.includes('read:export')) {
      window.location.href = '/admin/report-export';
    } else {
      push(ROUTES.APP.PROJECTS_CURRENT, {});
    }
  }, [permissions]);

  return null;
}
